import { BootstrapManager } from './BootstrapManager';

export { BootstrapManager } from './BootstrapManager';
export { BootstrapRepository } from './BootstrapRepository';
export {
  BootstrapState,
  BootstrapStateMessages,
  BootstrapStateNumbers,
  getBootstrapStateNumber,
  getBootstrapProgress
} from './enums';
export type { BootstrapStateData } from './BootstrapRepository';
export type { BootstrapManagerOptions } from './BootstrapManager';

// BootstrapManager should be singleton creating it here.

// Initialize with storage
export const bootstrapManager = new BootstrapManager({
  /*onStateChange: (stateData) => {
    internalLogger.log(
      `[BootstrapManager] State changed to: ${stateData.state}`
    );
  }*/
});
